import * as React from "react";
import { Button, Modal, Form } from "react-bootstrap";
import I18n from "lib/I18n";
import { EventMastersApi as Api } from "lib/Api";
import { call } from "lib/apiHelper";
import type { VersionNoteEditorProps } from "../startup/VersionNoteEditorApp/main";

export const App = (props: VersionNoteEditorProps) => {
  const [note, setNote] = React.useState(props.note || "");
  const [showModal, setShowModal] = React.useState(false);
  const [draftNote, setDraftNote] = React.useState("");

  const handleOpen = () => {
    setDraftNote(note);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleSave = async () => {
    const resp = await call(
      Api.updateVersionNoteEventMaster(props.eventMasterId, props.versionId, {
        note: draftNote,
      }),
    );
    if (resp.code === 200) {
      setNote(draftNote);
      setShowModal(false);
    }
  };

  return (
    <>
      <span className="d-flex align-items-start">
        <span style={{ whiteSpace: "pre-wrap" }}>{note}</span>
        <Button
          size="sm"
          variant="outline-secondary"
          className="ms-1 flex-shrink-0"
          onClick={handleOpen}
        >
          {"✎"}
        </Button>
      </span>
      <Modal animation={false} show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {I18n.t("event_master_editor.label.version_note")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Control
              as="textarea"
              rows={4}
              value={draftNote}
              onChange={(e) => setDraftNote(e.currentTarget.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {I18n.t("event_master_editor.action.close")}
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {I18n.t("event_master_editor.action.save")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
